import React from "react";
import ReactPlayer from "react-player";
import Badge from "~/admin/components/Badge";
import CategoryBadge from "~/admin/components/CategoryBadge";

export default function InformationsTab({ company }) {
  return (
    <>
      <div className="flex space-x-4 mb-2">
        <div className="text-xl">
          {company.name}
          {" - "}
          <span className="text-lg italic">Entreprise</span>
        </div>
        {company.user.checkStatus !== "valid" && (
          <Badge color="warning">{company.user.checkStatus}</Badge>
        )}
        {company.user.checkStatus === "valid" && (
          <>
            {company.user.visible ? (
              <Badge color="success">Visible</Badge>
            ) : (
              <Badge color="danger">Invisible</Badge>
            )}
          </>
        )}
      </div>
      <div className="flex flex-row space-x-1">
        {company.categories.map((category) => {
          return (
            <CategoryBadge key={category.id}>{category.name}</CategoryBadge>
          );
        })}
      </div>
      <div className="italic">{company.bio}</div>
      <div className="flex space-x-10 py-5">
        <div className="flex flex-col items-center">
          <div>Photo de profil</div>
          <img
            className="w-[150px]"
            src={company.profilePicture}
            alt="Profil"
          />
        </div>
        <div className="flex flex-col">
          <div>Photos</div>
          <div className="flex flex-row space-x-1">
            {company.swipePictures.map((image, key) => {
              return (
                <img
                  key={key}
                  className="w-[150px]"
                  src={image}
                  alt={`swipe ${key}`}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="max-w-[200px] relative my-6">
        <ReactPlayer url={company.video} width="100%" height="100%" controls />
      </div>
    </>
  );
}
